import { useAuthStore } from '@terminal/stores/use-auth/store/authStore';
import { getSession } from '@terminal/stores/use-auth/useAuth';
import { useEffect } from 'react';

// 1 hour
const REFRESH_INTERVAL_MS = 60 * 60 * 1000;

export const useSessionRefresh = () => {
  const { token, updateAuthStore } = useAuthStore(state => ({
    token: state.token,
    updateAuthStore: state.update,
  }));

  useEffect(() => {
    if (!token) {
      return;
    }

    const checkAndRefresh = async () => {
      const session = await getSession();

      if (session) {
        updateAuthStore(session, false);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkAndRefresh();
      }
    };

    const interval = setInterval(checkAndRefresh, REFRESH_INTERVAL_MS);

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [token, updateAuthStore]);
};
